import { column, edge, flow, makeFlow, node } from "../builders";
import type { TemplateDef } from "../types";

const seq = column("f1", 100, 70, 92, [
  ["t1", "auto-trigger", "Cancellation started", { props: { triggerType: "Form Submitted", event: "Cancel survey" } }],
  ["c1", "auto-condition", "Reason: too expensive?", { props: { condition: "cancel_reason is 'price'" } }],
  ["e1", "auto-email", "Would 50% for 3 months help?", { props: { subject: "Before you go — a smaller plan" } }],
  ["c2", "auto-condition", "Reason: not using it?", { props: { condition: "cancel_reason is 'not using it'" } }],
  ["e2", "auto-email", "Pause instead of cancel", { props: { subject: "Pause for 60 days, keep your data" } }],
  ["w1", "auto-wait", "Wait 3 days", { props: { duration: "3", unit: "days" } }],
  ["c3", "auto-condition", "Still cancelling?", { props: { condition: "Has tag 'cancelled'" } }],
  ["e3", "auto-email", "Door's open", { props: { subject: "Your data is kept for 90 days" } }],
  ["tg", "auto-tag-add", "Tag: churned", { props: { tag: "churned" } }],
]);

const def: TemplateDef = {
  slug: "churn-save-cancellation",
  name: "Churn Save / Cancellation Flow",
  category: "SaaS",
  tagline:
    "Ask why, then make the offer that answers that reason — not a blanket discount.",
  description:
    "A free churn-save template: a cancellation survey captures the reason, branches route price objections to a downgrade offer and dormancy to a pause offer, and anyone who leaves anyway gets a clean goodbye and a churned tag. Clone it into FrazzleCRM and run your cancel flow properly.",
  whatsInside: [
    "Cancellation survey that writes the reason to a contact field",
    "Price branch offering a discount or a smaller plan",
    "Dormancy branch offering a pause instead of a cancel",
    "Honest exit email plus a churned tag that feeds win-back later",
  ],
  flow: makeFlow(
    [
      node("app", "prov-main-app", "Your app", 40, 140),
      node("sv", "page-survey", "Cancel survey", 360, 140, { props: { questions: "2" } }),
      flow("f1", "Save Attempt", 680, 40, 420, 948),
      ...seq.nodes,
      node("sp", "page-sales", "Downgrade / pause offer", 1200, 260, { props: { price: "50% for 3 months" } }),
      node("out", "outcome-won", "Saved subscription", 1520, 260),
      node("n1", "util-note", "Route to win-back, don't delete", 360, 340, {
        notes:
          "The churned tag is the entry condition for the Win-Back template. A cancellation is a lead with a purchase history — the worst thing you can do with it is forget it.",
      }),
    ],
    [
      edge("app", "sv"),
      edge("sv", "f1"),
      ...seq.edges,
      edge("f1", "sp"),
      edge("sp", "out"),
    ]
  ),
};

export default def;
